<template>
    <CardDropdownSm :item="itemData">
        <template #icon>
            <TextFileIcon class="flex-shrink-0 h-5 ct-fg-4" />
        </template>
        <template #extra>
            <ButtonSecondaryIconSm v-if="isPublished(footer)" @click.stop="$emit('generate')">
                <PdfIcon />
            </ButtonSecondaryIconSm>
        </template>
    </CardDropdownSm>
</template>

<script>
import { markRaw } from "vue";
import { mapState, mapGetters } from "vuex";
import { TextFileIcon, PencilSquareIcon, CopyIcon, TrashBinIcon, PdfIcon } from "@easy/ui/icons";
import { CardDropdownSm } from "@easy/ui/cards";
import { ButtonSecondaryIconSm } from "@easy/ui/buttons";

export default {
    props: {
        nda: {
            type: Object,
            required: true,
        },
    },
    emits: ["edit", "duplicate", "delete", "generate"],
    components: { TextFileIcon, CardDropdownSm, PdfIcon, ButtonSecondaryIconSm },
    computed: {
        ...mapState("legal", ["footer"]),
        ...mapGetters(["isPublished"]),
        itemData() {
            return {
                title: this.nda.name,
                actions: [
                    this.isPublished(this.footer)
                        ? {
                              label: this.$t("legal.nda.generate_pdf"),
                              icon: markRaw(PdfIcon),
                              handler: () => {
                                  this.$emit("generate");
                              },
                          }
                        : {},
                    {
                        label: this.$t("shared.edit"),
                        icon: markRaw(PencilSquareIcon),
                        handler: () => {
                            this.$emit("edit");
                        },
                    },
                    {
                        label: this.$t("shared.duplicate"),
                        icon: markRaw(CopyIcon),
                        handler: () => {
                            this.$emit("duplicate");
                        },
                    },
                    { isDivider: true },
                    {
                        label: this.$t("shared.delete"),
                        icon: markRaw(TrashBinIcon),
                        isDanger: true,
                        handler: () => {
                            this.$emit("delete");
                        },
                    },
                ],
            };
        },
    },
};
</script>
